// Module
var code = "<template> <require from=\"app/cm/admin/acuity/acuities\"></require> <acuities></acuities> </template> ";
// Exports
module.exports = code;